import React, { useEffect, useState } from 'react'
import storage from '../../services/stoage.service'
import _ from 'lodash'
import apiService from '../../services/api-id-value-service'
import LtsMultiselectIdValue from './lts-multiselect-id-value'

export default function LtsMultiselectUnidade(props) {
  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    checkUnidade()
  }, [props.value, props.disabled])

  const checkUnidade = () => {
    if (props.disabled) {
      setDisabled(true)
      return
    }

    const currentUnit = storage.getUnit()
    if (!currentUnit) {
      setDisabled(false)
      return
    }

    const unidadeAtual = { id: currentUnit.oid, value: currentUnit.sigla }
    const unidadesSelecionadas = _.get(props, 'value', [])
    const possuiSomenteUnidadeAtual =
      Array.isArray(unidadesSelecionadas) &&
      unidadesSelecionadas.length === 1 &&
      _.get(unidadesSelecionadas, '[0].id', null) === unidadeAtual.id

    if (!possuiSomenteUnidadeAtual) {
      props.onChange({
        target: {
          name: props.name,
          value: [unidadeAtual],
        },
      })
    }

    setDisabled(true)
  }

  const afterLoadDataFn = (data) => {
    return data
  }

  return (
    <React.Fragment>
      <LtsMultiselectIdValue
        name={props.name}
        label={props.label}
        value={props.value}
        onChange={props.onChange}
        loadDataFn={apiService.getUnidadesUsuario}
        afterLoadDataFn={afterLoadDataFn}
        disabled={disabled}
      />
    </React.Fragment>
  )
}
